
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/challenges/[...slug]",
      function () {
        return require("private-next-pages/challenges/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/challenges/[...slug]"])
      });
    }
  